// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"535":"6a288c13","621":"943c7062"}[chunkId] + ".chunk.js";
};